import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Nav } from "../components/Nav";
import { useLang } from "../i18n";
import { api, apiError } from "../api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";
import { toast } from "sonner";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw.length < 8) return setErr(t("reset_min"));
    if (pw !== pw2) return setErr(t("reset_mismatch"));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(t("reset_done"));
      navigate("/login");
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="App min-h-screen">
      <Nav />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-serif text-4xl tracking-tight text-[#2B4A59] mb-2">{t("reset_title")}</h1>
        <p className="text-[#6E6B65] mb-8">{t("reset_sub")}</p>

        {!token ? (
          <p role="alert" className="text-sm text-[#B7410E]" data-testid="reset-no-token">{t("reset_no_token")}</p>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div>
              <Label htmlFor="reset-password">{t("reset_new")}</Label>
              <PasswordInput id="reset-password" name="new-password" autoComplete="new-password" minLength={8} data-testid="reset-password" required value={pw} onChange={(e) => setPw(e.target.value)} />
            </div>
            <div>
              <Label htmlFor="reset-password-confirm">{t("reset_confirm")}</Label>
              <PasswordInput id="reset-password-confirm" name="confirm-password" autoComplete="new-password" minLength={8} data-testid="reset-password-confirm" required value={pw2} onChange={(e) => setPw2(e.target.value)} />
            </div>
            {err && <p role="alert" className="text-sm text-[#B7410E]" data-testid="reset-error">{err}</p>}
            <Button data-testid="reset-submit" type="submit" disabled={busy} className="w-full rounded-full bg-[#3F6E85] hover:bg-[#2B4A59] h-12">
              {busy ? "..." : t("reset_submit")}
            </Button>
          </form>
        )}

        <p className="text-sm text-[#6E6B65] mt-6">
          <Link to="/login" className="text-[#B5651D] font-semibold" data-testid="reset-back-login">{t("login")}</Link>
        </p>
      </div>
    </div>
  );
}
